import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "分类浏览", to: "/category" },
  { label: "排行榜", to: "/rank" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

const categoryLinks = [
  "热血冒险",
  "玄幻仙侠",
  "都市异能",
  "科幻机甲",
  "奇幻魔法",
  "悬疑推理",
  "恋爱治愈",
  "美食日常",
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link
              to="/"
              className="font-heading text-2xl leading-none text-primary-700 dark:text-primary-400"
            >
              策驰漫画网
            </Link>
            <p className="mt-3 max-w-md text-sm leading-6 text-foreground-600">
              策驰漫画网专注中文漫画在线阅读,为读者带来流畅的翻页体验、便捷的目录跳转、可靠的收藏追更与自动同步的阅读记录,夜间模式贴心护眼,让你随时随地接着看。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-500">
              <a
                href="#"
                aria-label="微博"
                rel="nofollow"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-accent-500"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                aria-label="微信公众号"
                rel="nofollow"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-accent-500"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                aria-label="哔哩哔哩"
                rel="nofollow"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-accent-500"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-3 flex flex-col gap-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">热门分类</h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {categoryLinks.map((c) => (
                <Link
                  key={c}
                  to={`/category?type=${encodeURIComponent(c)}`}
                  className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 hover:bg-secondary-200 dark:bg-secondary-100/80"
                >
                  {c}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 策驰漫画网 · 畅享阅读,随时追更
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600">
              版权声明
            </Link>
            <Link to="/faq" className="hover:text-primary-600">
              帮助中心
            </Link>
            <Link to="/about" className="hover:text-primary-600">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}